import { render, staticRenderFns } from "./GroupPricing.vue?vue&type=template&id=eb0ae8a2&scoped=true"
import script from "./GroupPricing.vue?vue&type=script&lang=js"
export * from "./GroupPricing.vue?vue&type=script&lang=js"
import style0 from "./GroupPricing.vue?vue&type=style&index=0&id=eb0ae8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0ae8a2",
  null
  
)

export default component.exports